import type { CaseDefinition } from "../../domain/types/index.js";

export function sizeLabel(size: CaseDefinition["size"]): string {
  const map = { small: "小", medium: "中", large: "大", boss: "最終" } as const;
  return map[size];
}

export function nodeTitle(nodeId: string, caseName?: string): string {
  if (nodeId.startsWith("rest")) return "休日";
  return caseName ?? nodeId;
}
